import { parseLowLevelChildren } from "./parseLowLevelChildren.js";
export function parseChildren(path, state, app, options) {
  var _parseLowLevelChildre = parseLowLevelChildren([path], state, app, options),
    textContent = _parseLowLevelChildre.textContent,
    children = _parseLowLevelChildre.children;
  return children !== null && children !== void 0 ? children : [{
    name: "Plaintext",
    properties: {
      textContent: textContent
    }
  }];
}
//# sourceMappingURL=parseChildren.js.map